// extracted by mini-css-extract-plugin
export default {"list":"ActivityList_list__Tw2PS"};